enum OloHandoffMode {
  Pickup = 'pickup',
  Curbside = 'curbside',
  DriveThru = 'drivethru',
  Delivery = 'delivery',
  Dispatch = 'dispatch',
  DineIn = 'dinein',
}

export { OloHandoffMode };
